module.exports = __webpack_public_path__ + "img/FR19973.51f7e1a9.png";